import useSWR from "swr";
import { getValidCharacters } from "../services/template-service";

/**
 * Custom hook to fetch and cache valid characters data for a specific template.
 * Uses SWR for caching and automatic revalidation.
 */
const useValidCharacters = (templateId?: number) => {
  const { data, error, mutate } = useSWR(
    templateId ? `/cleaning/template/valid-characters/${templateId}` : null,
    () => (templateId ? getValidCharacters(templateId) : null),
  );

  return {
    validCharacters: data,
    isLoading: !error && !data && templateId !== undefined,
    isError: error,
    mutate,
  };
};

export default useValidCharacters;
